var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRollUp24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3     18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18      9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z",
    fill: "#DDDDDD",
    transform: "translate(0) rotate(180 11 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRollUp24Px);
export default __webpack_public_path__ + "static/media/menu_roll_up-24px.879194dc98056840caad598bc9cb71d6.svg";
export { ForwardRef as ReactComponent };